import { render, staticRenderFns } from "./ChatBoxFlex.vue?vue&type=template&id=1962d40a&scoped=true"
import script from "./ChatBoxFlex.vue?vue&type=script&lang=js"
export * from "./ChatBoxFlex.vue?vue&type=script&lang=js"
import style0 from "./ChatBoxFlex.vue?vue&type=style&index=0&id=1962d40a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1962d40a",
  null
  
)

export default component.exports